import {getBarWidth} from './getBarWidth.js';
import {INFO_COLUMN_WIDTH} from './constants.js';

// returns the step number based on the x-position (takes
// in account resolution)
export function getStepFromPosition(x, resolution, infoColumnWidth=INFO_COLUMN_WIDTH, zoom=1) {
    let width = getBarWidth(32, resolution, zoom);
    return Math.floor(
        32 * (x - infoColumnWidth) / width);
}
